
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/password_reset",
      function () {
        return require("private-next-pages/admin/password_reset.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/password_reset"])
      });
    }
  